export enum PageTypes {
  HOME = 'homepage',
  LANDING = 'landing',
  REVIEW = 'review',
  COUNTRY = 'country',
  TRANSFER = 'transfer',
  CURRENCY = 'currency',
  REDIRECT = 'redirect',
  APP = 'app',
}
